define('viewmodels/landing',['knockout', 'plugins/router', 'durandal/app', 'services/appsecurity', 'services/navigation', 'durandal/system', 'services/logger', 'services/utils', 'viewmodels/GeneralSettings', 'viewmodels/header', 'services/AppRoutes'],
    function (ko, router, app, appsecurity, navigation, system, logger, utils, ObjGeneralSettings, header, AppRoutes) {
        //Test ndm
        var DashboardVM = {
            title: ko.observable("Dashboard"),
            attached: attached,
            activate: activate,
            detached: detached,
            appsecurity: appsecurity,
            logger: logger,
            utils: utils,
            ObjGeneralSettings: ObjGeneralSettings,
            header: header,
            AppRoutes: AppRoutes,
            ComponentValueChange: ComponentValueChange,
            showSurveyInfoClick: showSurveyInfoClick,
            FilterProfileSurveys: FilterProfileSurveys,
            SurveyClick: SurveyClick,
            viewSurveyTimeline: viewSurveyTimeline,
            showWFDescription: showWFDescription,
            showTimelineComments: showTimelineComments,
            SwitchPageView: SwitchPageView,
            SearchResult: SearchResult,
            ResetSearch: ResetSearch,
            SearchKeyChange: SearchKeyChange,
            SearchDropdownChange: SearchDropdownChange,
            BUTitle: ko.observable('Business Unit'),
            RoutedFrom: ko.observable('Dashboard'),
            RoleValue: ko.observable(),
            CurrentProfileOfAssessmentId: ko.observable(),
            PendingCount: ko.observable(0),
            WorkInProgressCount: ko.observable(0),
            CompletedCount: ko.observable(0),
            TotalCount: ko.observable(0),
            ComponentsList: ko.observableArray([]),
            ComponentsMainList: ko.observableArray([]),
            DashboardData: ko.observableArray([]),
            SelectedComponentId: ko.observable(),
            SelectedComponentName: ko.observable('All'),
            SurveyStates: ko.observableArray([]),
            ResponseMoveArray: ko.observableArray([]),
            SurveyTimelineComments: ko.observableArray([]),
            UsersRoleWFList: ko.observableArray([]),
            AssessmentTypeList: ko.observableArray([]),
            SurveyType: ko.observable(),
            SelectedSurveyName: ko.observable(),
            TimelineCommentsFlag: ko.observable(false),
            showSurveysDivFlag: ko.observable(''),
            showDashboardFlag: ko.observable(false),
            showDashboardFlagCheck: ko.observable(),
            NavigatedFrom: ko.observable(''),
            SurveyPagesAccess: ko.observable(),
            SurveyResponseOnlyFlag: ko.observable(),
            LocaleCheckFlag: ko.observable(false),
            SearchQueryDashboard: ko.observable(''),
            SelectedSearchOptionId: ko.observable(''),
            SearchPlaceholder: ko.observable(''),
            SearchDropdownList: ko.observableArray([]),
            GlobalFilter: ko.observable(false),
            IsAccordFilter: ko.observable(false),
            LoadingMessage: ko.observable(),
            IsSearchClicked: ko.observable(true),
            SelectedAccordFilterId: ko.observable(''),
            SocioRATsData: ko.observableArray(),
            PendingWithNav: ko.observable(),
            SurveyStatusNav: ko.observable(),
            IsSurveyReadOnly: ko.observable()
        }; 

        return DashboardVM;

        // #region PageLoad Methods

        function activate() {
            try {

                if ($("#shellWrapper").hasClass('content-wrapper')) {
                    $("#shellWrapper").removeClass('content-wrapper');
                }
                DashboardVM.RoutedFrom("Dashboard");
                DashboardVM.showDashboardFlagCheck(false);
                DashboardVM.PendingCount(0);
                DashboardVM.WorkInProgressCount(0);
                DashboardVM.CompletedCount(0);
                DashboardVM.TotalCount(0);

                DashboardVM.appsecurity.initializeAuth().then(function (data) {
                    if (DashboardVM.appsecurity != undefined && DashboardVM.appsecurity.userInfo() != undefined) {

                        if (DashboardVM.ObjGeneralSettings === undefined || DashboardVM.ObjGeneralSettings.LocalizedTextList() === undefined || ((DashboardVM.ObjGeneralSettings.LocalizedTextList() !== undefined || DashboardVM.ObjGeneralSettings.LocalizedTextList() !== null) && DashboardVM.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                            DashboardVM.ObjGeneralSettings.GetLocalizedData().then(function () {
                                if (DashboardVM.ObjGeneralSettings.LocalizedTextList() == undefined || DashboardVM.ObjGeneralSettings.LocalizedTextList() == null || DashboardVM.ObjGeneralSettings.LocalizedTextList().length <= 0 || DashboardVM.ObjGeneralSettings.LocalizedIndexList() == undefined || DashboardVM.ObjGeneralSettings.LocalizedIndexList() == null)
                                    DashboardVM.LocaleCheckFlag(false);
                                else
                                    DashboardVM.LocaleCheckFlag(true);
                            });
                        }

                        DashboardVM.BUTitle((DashboardVM.ObjGeneralSettings.LocalizedTextList() == undefined || DashboardVM.ObjGeneralSettings.LocalizedTextList() == null || DashboardVM.ObjGeneralSettings.LocalizedTextList().length <= 0 || DashboardVM.ObjGeneralSettings.LocalizedIndexList() == undefined || DashboardVM.ObjGeneralSettings.LocalizedIndexList() == null || DashboardVM.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits') == -1) ? 'Business Unit' : DashboardVM.ObjGeneralSettings.LocalizedTextList()[DashboardVM.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits')].Name());


                        if (DashboardVM.appsecurity != undefined && DashboardVM.appsecurity.userInfo() !== undefined && DashboardVM.appsecurity.userInfo().PrimaryRoleId() !== undefined) {
                            DashboardVM.RoleValue(DashboardVM.appsecurity.userInfo().PrimaryRoleId());
                        }

                        DashboardVM.header.GetAssessmentTypeListForUser().then(function () {
                            DashboardVM.AssessmentTypeList(DashboardVM.header.hAssessmentTypeList());
                        });

                        if (DashboardVM.appsecurity.isConfigurationFreeze() === undefined) {
                            DashboardVM.appsecurity.GetConfigurationFreezeFlag();
                        }

                    }
                });
                $(".wrapper").css({ "background-color": "#000" });
                $(".main-sidebar").show();

            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | activate() in Dashboard.js';
                logger.logMessage(msg);
            }
        }

        function attached() {
            try {
                $("body").removeClass("login-page login-container");
                $("body").removeClass("login");
                $('body').removeClass('modal-open');
                $('.modal-backdrop').remove();
                $("#shellWrapper").addClass("wrapper");
                $("#master-header-content").addClass("content-wrapper");
                $(".main-sidebar").show();
                DefaultButton =
                    $("header").css({ "display": "block" });
                $('.static-header').hide();
                DashboardVM.RoutedFrom("Dashboard");
                DashboardVM.LoadingMessage('Loading... Please wait');
                DashboardVM.IsAccordFilter(false);
                $('#LoadingGIFDashBoardDiv').show();


                // fetching WriteAccess from PageList for SurveyResponse page using appsecurity.userInfo()
                if (DashboardVM.NavigatedFrom() != 'Response') {
                    var pageAccessCheck = 0;
                    if (appsecurity.userInfo().moduleList().length === 1 && appsecurity.userInfo().moduleList()[0].ModuleCodeName() === "survey") {
                        ko.utils.arrayFilter(appsecurity.userInfo().moduleList()[0].PageList(), function (arrInner) {
                            if (arrInner.PageCodeName() === "SurveyTracking" && (arrInner.WriteAccess() || arrInner.ReadAccess()))
                                pageAccessCheck++;
                            else if (arrInner.PageCodeName() === "ConfigureSurvey" && (arrInner.WriteAccess() || arrInner.ReadAccess()))
                                pageAccessCheck++;
                        });
                    }
                    else if (appsecurity.userInfo().moduleList().length === 1 && appsecurity.userInfo().moduleList()[0].ModuleCodeName() === "RaSocialization") {
                            ko.utils.arrayFilter(appsecurity.userInfo().moduleList()[0].PageList(), function (arrInner) {
                                if (arrInner.PageCodeName() === "RASAdministration" && (arrInner.WriteAccess() || arrInner.ReadAccess()))
                                    pageAccessCheck++;
                            });

                    }
                    else if (appsecurity.userInfo().moduleList().length === 2) {
                         if (appsecurity.userInfo().moduleList()[0].ModuleCodeName() === "survey" && appsecurity.userInfo().moduleList()[1].ModuleCodeName() === "RaSocialization") {
                         
                            ko.utils.arrayFilter(appsecurity.userInfo().moduleList()[0].PageList(), function (arrInner) {
                                if (arrInner.PageCodeName() === "SurveyTracking" && (arrInner.WriteAccess() || arrInner.ReadAccess()))
                                    pageAccessCheck++;
                                else if (arrInner.PageCodeName() === "ConfigureSurvey" && (arrInner.WriteAccess() || arrInner.ReadAccess()))
                                    pageAccessCheck++;
                            });
                            
                            ko.utils.arrayFilter(appsecurity.userInfo().moduleList()[1].PageList(), function (arrInner) {
                                if (arrInner.PageCodeName() === "RASAdministration" && (arrInner.WriteAccess() || arrInner.ReadAccess()))
                                    pageAccessCheck++;
                            });
                         }
                         else if (appsecurity.userInfo().moduleList()[0].ModuleCodeName() === "RaSocialization" && appsecurity.userInfo().moduleList()[1].ModuleCodeName() === "survey") {

                            ko.utils.arrayFilter(appsecurity.userInfo().moduleList()[1].PageList(), function (arrInner) {
                                if (arrInner.PageCodeName() === "SurveyTracking" && (arrInner.WriteAccess() || arrInner.ReadAccess()))
                                    pageAccessCheck++;
                                else if (arrInner.PageCodeName() === "ConfigureSurvey" && (arrInner.WriteAccess() || arrInner.ReadAccess()))
                                    pageAccessCheck++;
                            });

                            ko.utils.arrayFilter(appsecurity.userInfo().moduleList()[0].PageList(), function (arrInner) {
                                if (arrInner.PageCodeName() === "RASAdministration" && (arrInner.WriteAccess() || arrInner.ReadAccess()))
                                    pageAccessCheck++;
                            });
                        }
                        else {
                            pageAccessCheck = 1;
                        }
                    }
                    else {
                        pageAccessCheck = 1;
                    }

                    DashboardVM.SurveyPagesAccess(pageAccessCheck);
                    if (pageAccessCheck > 0) {
                        DashboardVM.showSurveysDivFlag(false);
                        DashboardVM.SurveyResponseOnlyFlag(false);
                    }
                    else {
                        DashboardVM.showSurveysDivFlag(true);
                        DashboardVM.SurveyResponseOnlyFlag(true);
                        $('#surveyErrorDiv').hide();
                        $('#surveyMainDiv').hide();
                    }
                }
                else {
                    DashboardVM.showSurveysDivFlag(true);
                    DashboardVM.NavigatedFrom('');
                    DashboardVM.SearchQueryDashboard('');
                    DashboardVM.IsSearchClicked(true);
                    $('#surveyErrorDiv').hide();
                    $('#surveyMainDiv').hide();
                }
                GetSurveys();

                // if (DashboardVM.ObjGeneralSettings === undefined || DashboardVM.ObjGeneralSettings.LocalizedTextList() === undefined || ((DashboardVM.ObjGeneralSettings.LocalizedTextList() !== undefined || DashboardVM.ObjGeneralSettings.LocalizedTextList() !== null) && DashboardVM.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                DashboardVM.ObjGeneralSettings.GetLocalizedData().then(function () {
                    if (DashboardVM.ObjGeneralSettings.LocalizedTextList() == undefined || DashboardVM.ObjGeneralSettings.LocalizedTextList() == null || DashboardVM.ObjGeneralSettings.LocalizedTextList().length <= 0 || DashboardVM.ObjGeneralSettings.LocalizedIndexList() == undefined || DashboardVM.ObjGeneralSettings.LocalizedIndexList() == null)
                        DashboardVM.LocaleCheckFlag(false);
                    else
                        DashboardVM.LocaleCheckFlag(true);
                });
                // }
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: attached() in Landing.js';
                logger.logMessage(msg);
            }
        }

        function detached() {
            try {
                $('#Masterdiv').addClass("pagelevelscroll");
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in Landing.js';
                logger.logMessage(msg);
            }
        }

        //#endregion


        //#region Get Methods

        function GetSurveys() {
            try {
                DashboardVM.appsecurity.GetCurrentProfileOfAssessment().then(function () {
                    DashboardVM.CurrentProfileOfAssessmentId(DashboardVM.appsecurity.CurrentProfileOfAssessmentId());

                    DashboardVM.showDashboardFlag(false);
                    var countCheck = 0;
                    // fetching Access from moduleList for surveys (RA, SOC) using appsecurity.userInfo()
                    var loopVar = ko.utils.arrayFirst(appsecurity.userInfo().moduleList(), function (arr) {
                        if (arr.ModuleCodeName() == "survey" || arr.ModuleCodeName() == "RaSocialization") {
                            if (arr.ModuleCodeName() == "survey") {
                                var loopSurvey = ko.utils.arrayFirst(arr.PageList(), function (arrInner) {
                                    if (arrInner.PageCodeName() === "SurveyResponse" && (arrInner.WriteAccess() || arrInner.ReadAccess())) {
                                        countCheck++;
                                        DashboardVM.showDashboardFlag(true);
                                        GetDashboardData();
                                        return true;
                                    }
                                });
                            }
                            else if (arr.ModuleCodeName() == "RaSocialization") {
                                var loopSoc = ko.utils.arrayFirst(arr.PageList(), function (arrInner) {
                                    if (arrInner.PageCodeName() === "SocializationResponse" && (arrInner.WriteAccess() || arrInner.ReadAccess())) {
                                        countCheck++;
                                        DashboardVM.showDashboardFlag(true);
                                        GetDashboardData();
                                        return true;
                                    }
                                });
                            }
                            return true;
                        }
                    });
                    if (countCheck == 0) {
                        $('#LoadingGIFDashBoardDiv').hide();
                        DashboardVM.showDashboardFlagCheck(true);
                    }
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetSurveys() method in Landing.js';
                logger.logMessage(msg);
            }
        }

        function GetDashboardData() {
            try {
                return $.ajax({
                    url: "/api/Survey/GetDashboardData?AssessmentProfileId=" + parseInt(DashboardVM.CurrentProfileOfAssessmentId()),
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: ajax call in GetDashboardData() in Landing.js';
                logger.logMessage(msg);

            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult !== "") {
                        if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                            logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(DashboardVM), true);
                        }
                        else {
                            var convertedObj = JSON.parse(jsonResult);
                            var mappedList = ko.mapping.fromJS(convertedObj.Components)();

                            if (mappedList.length === 1 && mappedList[0].ComponentId() === '-999') {
                                $('#surveyErrorDiv').show();
                                $('#surveyMainDiv').hide();
                            }
                            else {
                                $('#surveyErrorDiv').hide();
                                $('#surveyMainDiv').show();

                                DashboardVM.ComponentsMainList([]);
                                DashboardVM.ComponentsList([]);
                                DashboardVM.SocioRATsData([]);
                                // Start - Logic to fill all the surveys into 'All' Section - 0 is the default index in mappedList/DashboardVM.ComponentsList() for 'All' option
                                var j = 0;
                                var maxSeverity = 0;
                                while (j < mappedList[0].ProfilesCount()) {
                                    for (var i = 0; i < mappedList.length; i++) {
                                        if (mappedList[i].ComponentId() !== '-999') {
                                            for (var k = 0; k < mappedList[i].ProfilesData().length; k++) {
                                                mappedList[0].ProfilesData()[j] = mappedList[i].ProfilesData()[k];
                                                if (mappedList[i].ProfilesData()[k].ProfileSeverityOrder() > maxSeverity)
                                                    maxSeverity = mappedList[i].ProfilesData()[k].ProfileSeverityOrder();
                                                j++;

                                                // code to capture RAT vs Surveys/Profiles Data for socialization
                                                var socCompId = mappedList[i].ComponentId().toString().split('-');
                                                if (socCompId[0].toString().trim() == 'SOC')
                                                    DashboardVM.SocioRATsData.push({ ProfileId: mappedList[i].ProfilesData()[k].ProfileId(), RATId: socCompId[1] });

                                                // logic to add html part and modifications to BUList and RG Name attributes on Survey Card
                                                for (var m = 0; m < mappedList[i].ProfilesData()[k].SurveysData().length; m++) {
                                                    //RG Name code
                                                    var mainRGString = mappedList[i].ProfilesData()[k].SurveysData()[m].ProfileName_Survey();
                                                    var rgString = "";

                                                    if (mainRGString != null || mainRGString != "") {
                                                        var RGSplit = mainRGString.split("class='bu-val'>");
                                                        rgString = RGSplit[0] + " class='bu-val' title='" + RGSplit[1].split("</span></span>")[0].toString().trim() + "'>" + RGSplit[1];
                                                        mappedList[i].ProfilesData()[k].SurveysData()[m].ProfileName_Survey(rgString);
                                                    }

                                                }
                                            }
                                        }
                                    }
                                }
                                var tempList = [];
                                while (maxSeverity >= 0) {
                                    for (var k = 0; k < mappedList[0].ProfilesData().length; k++) {
                                        if (mappedList[0].ProfilesData()[k].ProfileSeverityOrder() == maxSeverity) {
                                            tempList.push(mappedList[0].ProfilesData()[k]);
                                        }
                                    }
                                    maxSeverity--;
                                }

                                for (var c = 0; c < mappedList[0].ProfilesData().length; c++) {
                                    mappedList[0].ProfilesData()[c] = tempList[c];
                                }
                                // End to fill all the surveys into 'All' Section - 0 is the default index in mappedList/DashboardVM.ComponentsList() for 'All' option

                                DashboardVM.ComponentsMainList(mappedList);
                                DashboardVM.ComponentsList(mappedList);
                                DashboardVM.SelectedComponentId(DashboardVM.ComponentsList()[0].ComponentId());
                                DashboardVM.SelectedComponentName(DashboardVM.ComponentsList()[0].ComponentName());
                                DashboardVM.PendingCount(DashboardVM.ComponentsList()[0].PendingSurveysCount());
                                DashboardVM.WorkInProgressCount(DashboardVM.ComponentsList()[0].ProgressSurveysCount());
                                DashboardVM.CompletedCount(DashboardVM.ComponentsList()[0].CompletedSurveysCount());
                                var totalCount = DashboardVM.PendingCount() + DashboardVM.WorkInProgressCount() + DashboardVM.CompletedCount();
                                DashboardVM.TotalCount(totalCount);
                                var mappedStatesList = ko.mapping.fromJS(convertedObj.States)();
                                DashboardVM.SurveyStates(mappedStatesList);

                                //Search By - Dropdown List data fill
                                var mappedDropdownList = ko.mapping.fromJS(convertedObj.SearchDropdownList)();
                                DashboardVM.SearchDropdownList(mappedDropdownList);
                                DashboardVM.SelectedSearchOptionId(DashboardVM.SearchDropdownList()[0].SearchOptionId());
                                DashboardVM.SearchPlaceholder(DashboardVM.SearchDropdownList()[0].SearchPlaceholder());
                            }
                        }
                    }
                    else {
                        $('#surveyErrorDiv').show();
                        $('#surveyMainDiv').hide();
                    }
                    $('#LoadingGIFDashBoardDiv').hide();
                    DashboardVM.showDashboardFlagCheck(true);
                }
                catch (e) {
                    $('#LoadingGIFDashBoardDiv').hide();
                    var msg = 'Exception' + e + ' | Source: ajaxSuccess in GetDashboardData() in Landing.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    $('#LoadingGIFDashBoardDiv').hide();
                    if (error.status === 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetDashboardData() method in Landing.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetDashboardData() method in Landing.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetSurveyCardDetails(SurveyId, ProfileId, SurveyType, WFFlag) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({                  
                    url: "/api/Survey/GetSurveyCardDetails",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    type: "POST",
                    headers: headers,
                    data: ko.toJSON({ Draft: SurveyId, SurveyType: SurveyType, AssessmentProfileId: parseInt(DashboardVM.CurrentProfileOfAssessmentId()), WFFlag: WFFlag })
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetSurveyCardDetails() method in Landing.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult !== "") {

                        var convertedObj = JSON.parse(jsonResult);
                        var mappedList = ko.mapping.fromJS(convertedObj.SurveyDetails)();

                        if (WFFlag == 0) {
                            // org levels and user list 
                            var userListVar = mappedList[0].UserList();
                            var buListVar = mappedList[0].BUList();
                            var BUlistStringHTML = "";

                            // to add title to sub-org level names
                            if (buListVar != null || buListVar != "") {
                                var BUListSplit = buListVar.split("<span class='bu-lbl'><strong class='lbl-space'>");
                                for (var n = 1; n < BUListSplit.length; n++) {
                                    var BUListSplitInner = BUListSplit[n].toString().split(":</strong><span class='bu-val'>");
                                    BUlistStringHTML += "<span class='bu-lbl'><strong class='lbl-space'>" + BUListSplitInner[0] + ":</strong><span class='bu-val' title='" + BUListSplitInner[1].split("</span></span>")[0].toString().trim() + "'>" + BUListSplitInner[1];
                                }
                            }
                            document.getElementById('surveyOrgListDiv_' + SurveyId + '_' + ProfileId).innerHTML = BUlistStringHTML;
                            document.getElementById('surveyUsersListDiv_' + SurveyId + '_' + ProfileId).innerHTML = userListVar;
                        }
                        else {
                            // pending with and survey status for surveys navgation from pending to in-progress state
                            DashboardVM.PendingWithNav(mappedList[0].PendingWith());
                            DashboardVM.SurveyStatusNav(mappedList[0].SurveyStatus());
                        }
                    }
                    else {
                        // user and org details are null
                    }
                }
                catch (e) {
                    $('#LoadingGIFDashBoardDiv').hide();
                    var msg = 'Exception' + e + ' | Source: ajaxSuccess in GetSurveyCardDetails() in Landing.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    $('#LoadingGIFDashBoardDiv').hide();
                    if (error.status === 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyCardDetails() method in Landing.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetSurveyCardDetails() method in Landing.js';
                    logger.logMessage(msg);
                }
            }
        }

        // Timeline Button Click Event and Get Method
        function viewSurveyTimeline(data) {
            try {
                var commentType = 'PBC';
                DashboardVM.TimelineCommentsFlag(false);
                DashboardVM.SelectedSurveyName(data.SurveyName());
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Survey/GetSurveyLevelComments",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    type: "POST",
                    headers: headers,
                    data: ko.toJSON({ Draft: data.SurveyId(), SurveyType: data.SurveyType(), CommentType: commentType, AssessmentProfileId: parseInt(DashboardVM.CurrentProfileOfAssessmentId()) })
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: viewSurveyTimeline() method in Landing.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult !== "") {
                        if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                            logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(DashboardVM), true);
                        }
                        else {
                            $('#noTimelineComments').hide();
                            $('#commentsTimeline').show();
                            DashboardVM.SurveyTimelineComments([]);
                            var convertedObj = JSON.parse(jsonResult);
                            var mappedList = ko.mapping.fromJS(convertedObj.Comments)();
                            DashboardVM.SurveyTimelineComments(mappedList);
                            $('#showCmpltTimelineBtn').show();
                            $('#showLessTimelineBtn').hide();
                        }
                    }
                    else {
                        $('#noTimelineComments').show();
                        $('#commentsTimeline').hide();
                        $('#showCmpltTimelineBtn').hide();
                        $('#showLessTimelineBtn').hide();
                    }
                    GetUsersRoleWFDetails(data);
                    $('#SurveyTimelinePopUp').modal('show');
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in viewSurveyTimeline() method in Landing.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in viewSurveyTimeline() method in Landing.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in viewSurveyTimeline() method in Landing.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetUsersRoleWFDetails(data) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    url: "/api/Configuration/GetRoleUserDetailsForBUSocializationWorkFLow",
                    data: ko.toJSON({
                        "SurveyId": data.SurveyId(),
                        "Survey_type": data.SurveyType()
                    }),
                    type: "POST",
                    headers: headers
                })
               .success(function (jsonResult, success) {
                        DashboardVM.UsersRoleWFList([]);
                        if (jsonResult === null) {
                            $('#UsersRoleWFChevrons').hide();
                        }
                        if (jsonResult.length > 0 && jsonResult !== null) {
                            if (jsonResult[0].RoleID == -99) {
                                logger.logError(jsonResult[0].RoleName + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(DashboardVM), true);
                            }
                            else {
                                $('#UsersRoleWFChevrons').show();
                                DashboardVM.UsersRoleWFList(jsonResult);
                            }
                        }
                    })
                    .fail(function (error, status) {
                        try {
                            if (error.status === 401) {
                                app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                    .then(function (option) {
                                        if (option === "OK")
                                            navigation.unauthorized();
                                    });
                            }
                            else {
                                var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetUsersRoleWFDetails() method in Landing.js';
                                logger.logMessage(msg);
                            }
                        } catch (e) {
                            var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetUsersRoleWFDetails() method in Landing.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in GetUsersRoleWFDetails() method in Landing.js';
                logger.logMessage(msg);
            }
        }

        //#endregion


        //#region Event Clicks

        function SwitchPageView(data, btnName) {
            try {
                if (data === "Dashboard") {
                    if (!DashboardVM.showSurveysDivFlag()) {
                        DashboardVM.showSurveysDivFlag(true);

                        DashboardVM.SelectedComponentId('-999');
                        DashboardVM.GlobalFilter(btnName != undefined ? true : false);
                        ComponentValueChange();
                        if (btnName != undefined) {
                            $('#countDiv span').removeClass("active-filter");
                            $('#' + btnName + 'Count').addClass("active-filter");
                            DashboardVM.LoadingMessage('Loading... Please wait');
                            FilterProfileSurveys(DashboardVM.DashboardData(), btnName);
                            if (DashboardVM.DashboardData().length > 0) {
                                // clicking the "first" accordion to show it as expanded by default
                                document.getElementById("collapse_parent_" + DashboardVM.DashboardData()[0].ProfileId()).click();
                            }
                        }
                    }
                    else {
                        if (btnName != undefined) {
                            DashboardVM.GlobalFilter(true);
                            $('#countDiv span').removeClass("active-filter");
                            $('#' + btnName + 'Count').addClass("active-filter");
                            DashboardVM.LoadingMessage('Loading... Please wait');
                            FilterProfileSurveys(DashboardVM.DashboardData(), btnName);
                        }
                    }
                }
                else if (data === "Landing") {
                    // collapsing all other accordions
                    if (DashboardVM.DashboardData().length > 0) {
                        for (var i = 0; i < DashboardVM.DashboardData().length; i++) {
                            if (!$('#collapse_parent_' + DashboardVM.DashboardData()[i].ProfileId()).hasClass("collapsed"))
                                document.getElementById("collapse_parent_" + DashboardVM.DashboardData()[i].ProfileId()).click();
                        }
                    }
                    DashboardVM.showSurveysDivFlag(false);
                }
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: SwitchPageView() method in Landing.js';
                logger.logMessage(msg);
            }
        }

        function ComponentValueChange() {
            try {
                var MainArray = [];
                MainArray = JSON.parse(ko.toJSON(DashboardVM.ComponentsMainList()));
                DashboardVM.ComponentsList(ko.mapping.fromJS(MainArray)());
                for (var i = 0; i < DashboardVM.ComponentsList().length; i++) {
                    if (DashboardVM.ComponentsList()[i].ComponentId() === DashboardVM.SelectedComponentId()) {
                        DashboardVM.SelectedComponentName(DashboardVM.ComponentsList()[i].ComponentName());
                        DashboardVM.DashboardData(DashboardVM.ComponentsList()[i].ProfilesData());
                        break;
                    }
                }
                $('#countDiv span').removeClass("active-filter");
                if (DashboardVM.showSurveysDivFlag() && !DashboardVM.GlobalFilter()) {
                    if (DashboardVM.DashboardData().length > 0) {
                        // clicking the "first" accordion to show it as expanded by default
                        document.getElementById("collapse_parent_" + DashboardVM.DashboardData()[0].ProfileId()).click();
                    }
                }
                DashboardVM.LoadingMessage('Loading... Please wait');
                if (DashboardVM.SearchQueryDashboard() != '')
                    SearchResult(true);

                $('#loadingSearchImgDiv').hide();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ComponentValueChange() method in Landing.js';
                logger.logMessage(msg);
            }
        }

        function showSurveyInfoClick(SurveyId, ProfileId, SurveyType) {
            try {
                if (document.getElementById('surveyOrgListDiv_' + SurveyId + '_' + ProfileId).innerHTML == "" && document.getElementById('surveyUsersListDiv_' + SurveyId + '_' + ProfileId).innerHTML == "") {
                    GetSurveyCardDetails(SurveyId, ProfileId, SurveyType, 0);
                }
                if ($('#surveyInfoDiv_' + SurveyId + '_' + ProfileId).is(':visible')) {
                    $('#surveyInfoDiv_' + SurveyId + '_' + ProfileId).hide();
                    $('#surveyInfoDivMore_' + SurveyId + '_' + ProfileId).show();
                    $('#surveyInfoDivLess_' + SurveyId + '_' + ProfileId).hide();
                }
                else {
                    $('#surveyInfoDiv_' + SurveyId + '_' + ProfileId).show();
                    $('#surveyInfoDivLess_' + SurveyId + '_' + ProfileId).show();
                    $('#surveyInfoDivMore_' + SurveyId + '_' + ProfileId).hide();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: showSurveyInfoClick() method in Landing.js';
                logger.logMessage(msg);
            }
        }

        function FilterProfileSurveys(Profiles, selectedFilter) {
            try {
                var profileId = '';
                if (!DashboardVM.GlobalFilter()) {
                    $('#filterList_' + Profiles.ProfileId() + ' li a').removeClass("active");
                    $('#' + selectedFilter + Profiles.ProfileId()).addClass("active");
                    $('#NoFilteredSurveys_' + Profiles.ProfileId()).hide();
                    $('#NoFilteredSurveysMsg_' + Profiles.ProfileId()).html("");

                    DashboardVM.IsAccordFilter(true);
                    DashboardVM.SelectedAccordFilterId(Profiles.ProfileId());
                    profileId = Profiles.ProfileId();
                }
                for (var i = 0; i < DashboardVM.DashboardData().length; i++) {
                    if (profileId === DashboardVM.DashboardData()[i].ProfileId() || DashboardVM.GlobalFilter()) {

                        if (DashboardVM.GlobalFilter()) {
                            $('#filterList_' + Profiles[i].ProfileId() + ' li a').removeClass("active");
                            $('#' + selectedFilter + Profiles[i].ProfileId()).addClass("active");
                            $('#NoFilteredSurveys_' + Profiles[i].ProfileId()).hide();
                            $('#NoFilteredSurveysMsg_' + Profiles[i].ProfileId()).html("");
                        }
                        DashboardVM.DashboardData()[i].SelectedFilter(selectedFilter);
                    }
                }
                SearchResult(DashboardVM.IsSearchClicked() ? false : true);
                DashboardVM.IsAccordFilter(false);
                DashboardVM.SelectedAccordFilterId('');
                if (DashboardVM.GlobalFilter())
                    DashboardVM.GlobalFilter(false);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: FilterProfileSurveys() method in Landing.js';
                logger.logMessage(msg);
            }
        }

        function showWFDescription(data, event) {
            try {
                if ($('#WFDescDiv').is(':visible')) {
                    $('#WFDescDiv').hide();
                    $('#showWFDescBtn').show();
                    $('#hideWFDescBtn').hide();
                }
                else {
                    $('#WFDescDiv').show();
                    $('#hideWFDescBtn').show();
                    $('#showWFDescBtn').hide();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: showWFDescription() method in Landing.js';
                logger.logMessage(msg);
            }
        }

        function showTimelineComments(data, event) {
            try {
                if ($('#showCmpltTimelineBtn').is(':visible')) {
                    DashboardVM.TimelineCommentsFlag(true);
                    $('#showCmpltTimelineBtn').hide();
                    $('#showLessTimelineBtn').show();
                }
                else {
                    DashboardVM.TimelineCommentsFlag(false);
                    $('#showCmpltTimelineBtn').show();
                    $('#showLessTimelineBtn').hide();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: showWFDescription() method in Landing.js';
                logger.logMessage(msg);
            }
        }

        function SurveyClick(Surveys, Profiles) {
            try {
                DashboardVM.SurveyType(Surveys.SurveyType());
                if (Surveys.IsAvailableFlag() && Surveys.IsPendingFlag() && !Surveys.IsSurveyReadOnly()) {
                    var surveyTypeVar = "";
                    if (Surveys.SurveyType() === 'SUR')
                        surveyTypeVar = "SURVEY";
                    if (Surveys.SurveyType() === 'SOC')
                        surveyTypeVar = "BUSINESS UNIT";
                    if (Surveys.SurveyType() === 'PCS')
                        surveyTypeVar = "RR";

                    if (Surveys.EventId() != -1 && Surveys.WPECommentText() != " ") {
                        $('#surveyErrorDiv').hide();
                        $('#surveyMainDiv').hide();
                        $('#LoadingGIFDashBoardDiv').show();

                        MoveSurveyToWorkInProgress(Surveys, surveyTypeVar, Profiles);
                    }
                    else {
                        app.showMessage("You are not allowed to perform this action.", "Action cannot be performed", [" OK"], false, { buttonClass: "fa fa-check btn", primaryButtonClass: "secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                            .then(function (option) {

                            });
                    }
                }
                else {
                    if (Surveys.SurveyType() === 'SUR')
                        NavigateSurveyResponse(Surveys, Profiles);
                    if (Surveys.SurveyType() === 'SOC')
                        NavigateSocializationResponse(Surveys, Profiles)
                    if (Surveys.SurveyType() === 'PCS')
                        NavigatePRRResponse(Surveys, Profiles);
                }
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | SurveyClick() in Landing.js';
                logger.logMessage(msg);
            }
        }

        function SearchResult(isSearch) {
            try {
                $('#noMatchesFound').hide();
                var waitTime = 0;
                var searchQuery = DashboardVM.SearchQueryDashboard().toString().toLowerCase().replace(/\s/g, '');
                if (!DashboardVM.IsAccordFilter()) {
                    if (searchQuery != '')
                        $('#loadingSearchImgDiv').show();
                    waitTime = (DashboardVM.TotalCount() > 0 && DashboardVM.TotalCount() <= 25) ? 0 : (DashboardVM.TotalCount() > 25 && DashboardVM.TotalCount() <= 75) ? 500 : (DashboardVM.TotalCount() > 75 && DashboardVM.TotalCount() <= 150) ? 1500 : 2000;
                }

                if (isSearch) {
                    var tempList = DashboardVM.DashboardData();
                    DashboardVM.DashboardData([]);
                    DashboardVM.DashboardData(tempList);
                    if (!DashboardVM.GlobalFilter())
                        DashboardVM.LoadingMessage('Searching... Please wait');
                    DashboardVM.IsSearchClicked(true);
                }
                var selectedFilter = '';
                var selectedFilterDisplay = '';
                var countFilter = 0;

                if (searchQuery != '') {
                    $('#clearSearch').show();
                    for (var i = 0; i < DashboardVM.DashboardData().length; i++) {

                        if ((DashboardVM.SelectedAccordFilterId() == DashboardVM.DashboardData()[i].ProfileId() && DashboardVM.IsAccordFilter()) ||
                            (!DashboardVM.IsAccordFilter())) {

                            selectedFilter = DashboardVM.DashboardData()[i].SelectedFilter();
                            countFilter = 0;

                            // initially hiding the survey profile bucket for Search
                            if (isSearch)
                                DashboardVM.DashboardData()[i].IsVisibleFlag_Profile(false);

                            // setting the filter to 'All' by default in each survey profile bucket
                            $('#filterList_' + DashboardVM.DashboardData()[i].ProfileId() + ' li a').removeClass("active");
                            $('#' + selectedFilter + DashboardVM.DashboardData()[i].ProfileId()).addClass("active");
                            $('#NoFilteredSurveys_' + DashboardVM.DashboardData()[i].ProfileId()).hide();
                            $('#NoFilteredSurveysMsg_' + DashboardVM.DashboardData()[i].ProfileId()).html("");

                            for (var j = 0; j < DashboardVM.DashboardData()[i].SurveysData().length; j++) {


                                DashboardVM.DashboardData()[i].SurveysData()[j].IsVisibleFlag(false);
                                var searchAreaJson = ko.toJSON(DashboardVM.DashboardData()[i].SurveysData()[j]);
                                var searchArea = searchAreaJson.split(',"');

                                // logic to select only the visible content on the screen and to hide Ids and Flags for search
                                var separatedStr = [];
                                var searchAreaStr = '';
                                ko.utils.arrayFilter(searchArea, function (arr) {
                                    ko.utils.arrayFilter(DashboardVM.SearchDropdownList(), function (arrInner) {

                                        // if condition to handle CompletedBy and PendingWith filter using IsCompletedFlag as both of them uses same observable for data-binding
                                        if ((arr.split('":')[0].toString() === arrInner.SearchOptionId() && arrInner.SearchOptionId() != "CompletedBy" && arrInner.SearchOptionId() != "PendingWith") ||
                                            (arr.split('":')[0].toString() === "PendingWith" && arrInner.SearchOptionId() == "CompletedBy" && DashboardVM.DashboardData()[i].SurveysData()[j].IsCompletedFlag()) ||
                                            (arr.split('":')[0].toString() === arrInner.SearchOptionId() && arrInner.SearchOptionId() == "PendingWith" && !DashboardVM.DashboardData()[i].SurveysData()[j].IsCompletedFlag())) {
                                            separatedStr.push(arr);
                                            searchAreaStr += arr.split('":')[1].toString();
                                        }
                                    });
                                });

                                if (DashboardVM.SelectedSearchOptionId() == "EntirePage") {
                                    if (searchAreaStr.toLowerCase().replace(/({|}|")/gi, '').replace(/\s/g, '').indexOf(searchQuery) >= 0) {

                                        DashboardVM.DashboardData()[i].SurveysData()[j].IsVisibleFlag(true);
                                        DashboardVM.DashboardData()[i].IsVisibleFlag_Profile(true);

                                        if (selectedFilter === 'All') {
                                            DashboardVM.DashboardData()[i].SurveysData()[j].IsVisibleFlag(true);
                                            DashboardVM.DashboardData()[i].IsVisibleFlag_Profile(true);
                                            countFilter++;
                                        }
                                        else if (selectedFilter === 'Pending' && DashboardVM.DashboardData()[i].SurveysData()[j].IsPendingFlag()) {
                                            DashboardVM.DashboardData()[i].SurveysData()[j].IsVisibleFlag(true);
                                            DashboardVM.DashboardData()[i].IsVisibleFlag_Profile(true);
                                            countFilter++;
                                        }
                                        else if (selectedFilter === 'InProgress' && DashboardVM.DashboardData()[i].SurveysData()[j].IsInProgressFlag()) {
                                            DashboardVM.DashboardData()[i].SurveysData()[j].IsVisibleFlag(true);
                                            DashboardVM.DashboardData()[i].IsVisibleFlag_Profile(true);
                                            countFilter++;
                                        }
                                        else if (selectedFilter === 'Completed' && DashboardVM.DashboardData()[i].SurveysData()[j].IsCompletedFlag()) {
                                            DashboardVM.DashboardData()[i].SurveysData()[j].IsVisibleFlag(true);
                                            DashboardVM.DashboardData()[i].IsVisibleFlag_Profile(true);
                                            countFilter++;
                                        }
                                        else {
                                            DashboardVM.DashboardData()[i].SurveysData()[j].IsVisibleFlag(false);
                                        }
                                    }
                                }
                                else {
                                    // to handle CompletedBy and PendingWith filter as both of them uses same observable for data-binding
                                    var optId = DashboardVM.SelectedSearchOptionId() == "CompletedBy" ? "PendingWith" : DashboardVM.SelectedSearchOptionId();
                                    var filteredStr = '';
                                    filteredStr = ko.utils.arrayFilter(separatedStr, function (arr) {
                                        if (arr.split('":')[0].toString() === optId) {
                                            return arr;
                                        }
                                    });
                                    if (filteredStr.length > 0) {
                                        var finalValue = $('<div/>').html(filteredStr[0].split('":')[1].toString()).text();
                                        if (filteredStr[0].split('":')[0].toString() == "ProfileName_Survey")  // to remove Responsibility Group Heading from search text
                                            finalValue = finalValue.split(':')[1].toString();

                                        // cleaning final search text
                                        finalValue = finalValue.toString().toLowerCase().replace(/({|}|")/gi, '').replace(/\s/g, '');

                                        // if condition to handle CompletedBy and PendingWith filter using IsCompletedFlag as both of them uses same observable for data-binding
                                        if ((finalValue.indexOf(searchQuery) >= 0 && DashboardVM.SelectedSearchOptionId() != "CompletedBy" && DashboardVM.SelectedSearchOptionId() != "PendingWith") ||
                                            (finalValue.indexOf(searchQuery) >= 0 && DashboardVM.SelectedSearchOptionId() == "CompletedBy" && DashboardVM.DashboardData()[i].SurveysData()[j].IsCompletedFlag()) ||
                                            (finalValue.indexOf(searchQuery) >= 0 && DashboardVM.SelectedSearchOptionId() == "PendingWith" && !DashboardVM.DashboardData()[i].SurveysData()[j].IsCompletedFlag())) {

                                            DashboardVM.DashboardData()[i].SurveysData()[j].IsVisibleFlag(true);
                                            DashboardVM.DashboardData()[i].IsVisibleFlag_Profile(true);

                                            if (selectedFilter === 'All') {
                                                DashboardVM.DashboardData()[i].SurveysData()[j].IsVisibleFlag(true);
                                                DashboardVM.DashboardData()[i].IsVisibleFlag_Profile(true);
                                                countFilter++;
                                            }
                                            else if (selectedFilter === 'Pending' && DashboardVM.DashboardData()[i].SurveysData()[j].IsPendingFlag()) {
                                                DashboardVM.DashboardData()[i].SurveysData()[j].IsVisibleFlag(true);
                                                DashboardVM.DashboardData()[i].IsVisibleFlag_Profile(true);
                                                countFilter++;
                                            }
                                            else if (selectedFilter === 'InProgress' && DashboardVM.DashboardData()[i].SurveysData()[j].IsInProgressFlag()) {
                                                DashboardVM.DashboardData()[i].SurveysData()[j].IsVisibleFlag(true);
                                                DashboardVM.DashboardData()[i].IsVisibleFlag_Profile(true);
                                                countFilter++;
                                            }
                                            else if (selectedFilter === 'Completed' && DashboardVM.DashboardData()[i].SurveysData()[j].IsCompletedFlag()) {
                                                DashboardVM.DashboardData()[i].SurveysData()[j].IsVisibleFlag(true);
                                                DashboardVM.DashboardData()[i].IsVisibleFlag_Profile(true);
                                                countFilter++;
                                            }
                                            else {
                                                DashboardVM.DashboardData()[i].SurveysData()[j].IsVisibleFlag(false);
                                            }
                                        }
                                    }
                                }
                            }

                            if (countFilter === 0) {
                                selectedFilterDisplay = selectedFilter;
                                if (selectedFilter === 'InProgress')
                                    selectedFilterDisplay = 'In Progress'
                                $('#NoFilteredSurveysMsg_' + DashboardVM.DashboardData()[i].ProfileId()).html("No surveys are " + selectedFilterDisplay);
                                $('#NoFilteredSurveys_' + DashboardVM.DashboardData()[i].ProfileId()).show();
                            }
                        }
                    }
                }

                else {
                    $('#clearSearch').hide();
                    for (var i = 0; i < DashboardVM.DashboardData().length; i++) {

                        if ((DashboardVM.SelectedAccordFilterId() == DashboardVM.DashboardData()[i].ProfileId() && DashboardVM.IsAccordFilter()) ||
                            (!DashboardVM.IsAccordFilter())) {
                            selectedFilter = DashboardVM.DashboardData()[i].SelectedFilter();
                            countFilter = 0;

                            DashboardVM.DashboardData()[i].IsVisibleFlag_Profile(true);
                            // setting the filter to 'All' by default in each survey profile bucket
                            $('#filterList_' + DashboardVM.DashboardData()[i].ProfileId() + ' li a').removeClass("active");
                            $('#' + selectedFilter + DashboardVM.DashboardData()[i].ProfileId()).addClass("active");
                            $('#NoFilteredSurveys_' + DashboardVM.DashboardData()[i].ProfileId()).hide();
                            $('#NoFilteredSurveysMsg_' + DashboardVM.DashboardData()[i].ProfileId()).html("");
                            for (var j = 0; j < DashboardVM.DashboardData()[i].SurveysData().length; j++) {

                                if (selectedFilter === 'All') {
                                    countFilter++;
                                    DashboardVM.DashboardData()[i].SurveysData()[j].IsVisibleFlag(true);
                                }
                                else if (selectedFilter === 'Pending' && DashboardVM.DashboardData()[i].SurveysData()[j].IsPendingFlag()) {
                                    countFilter++;
                                    DashboardVM.DashboardData()[i].SurveysData()[j].IsVisibleFlag(true);
                                }
                                else if (selectedFilter === 'InProgress' && DashboardVM.DashboardData()[i].SurveysData()[j].IsInProgressFlag()) {
                                    countFilter++;
                                    DashboardVM.DashboardData()[i].SurveysData()[j].IsVisibleFlag(true);
                                }
                                else if (selectedFilter === 'Completed' && DashboardVM.DashboardData()[i].SurveysData()[j].IsCompletedFlag()) {
                                    countFilter++;
                                    DashboardVM.DashboardData()[i].SurveysData()[j].IsVisibleFlag(true);
                                }
                                else
                                    DashboardVM.DashboardData()[i].SurveysData()[j].IsVisibleFlag(false);

                            }
                            if (countFilter === 0) {
                                selectedFilterDisplay = selectedFilter;
                                if (selectedFilter === 'InProgress')
                                    selectedFilterDisplay = 'In Progress'
                                $('#NoFilteredSurveysMsg_' + DashboardVM.DashboardData()[i].ProfileId()).html("No surveys are " + selectedFilterDisplay);
                                $('#NoFilteredSurveys_' + DashboardVM.DashboardData()[i].ProfileId()).show();
                            }
                        }
                    }
                }
                var accordIndex = 0;
                var profileCount = 0;
                for (var i = 0; i < DashboardVM.DashboardData().length; i++) {
                    if (DashboardVM.DashboardData()[i].IsVisibleFlag_Profile()) {
                        accordIndex = i;
                        profileCount++;
                        break;
                    }
                }
                if (profileCount == 0) {
                    $('#noMatchesFound').show();
                }
                else {
                    $('#noMatchesFound').hide();
                    if (DashboardVM.DashboardData().length > 0 && isSearch) {
                        // clicking the "first" accordion to show it as expanded and clsoing the remaining accordions
                        for (var i = 0; i < DashboardVM.DashboardData().length; i++) {
                            if (accordIndex == i && $('#collapse_parent_' + DashboardVM.DashboardData()[i].ProfileId()).hasClass("collapsed")) {
                                document.getElementById("collapse_parent_" + DashboardVM.DashboardData()[i].ProfileId()).click();
                            }
                            else if (accordIndex != i && !$('#collapse_parent_' + DashboardVM.DashboardData()[i].ProfileId()).hasClass("collapsed")) {
                                document.getElementById("collapse_parent_" + DashboardVM.DashboardData()[i].ProfileId()).click();
                            }
                        }
                    }
                }
                if (waitTime != 0) {
                    setTimeout(function () {
                        $('#loadingSearchImgDiv').hide();
                    }, waitTime);
                }
                else {
                    $('#loadingSearchImgDiv').hide();
                }
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | SearchResult() in Landing.js';
                logger.logMessage(msg);
            }
        }

        function ResetSearch() {
            try {
                $('#clearSearch').hide();
                $('#noMatchesFound').hide();
                DashboardVM.SearchQueryDashboard('');
                SearchResult(true);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | ResetSearch() in Landing.js';
                logger.logMessage(msg);
            }
        }

        function SearchKeyChange() {
            try {
                if (DashboardVM.SearchQueryDashboard() != "") {
                    $('#clearSearch').show();
                    DashboardVM.IsSearchClicked(false);
                }
                else {
                    $('#clearSearch').hide();
                    DashboardVM.IsSearchClicked(true);
                }

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SearchKeyChange() method in Landing.js';
                logger.logMessage(msg);
            }
        }

        function SearchDropdownChange() {
            try {
                // filling Placeholder for Search
                ko.utils.arrayFilter(DashboardVM.SearchDropdownList(), function (arr) {
                    if (arr.SearchOptionId() == DashboardVM.SelectedSearchOptionId()) {
                        DashboardVM.SearchPlaceholder(arr.SearchPlaceholder());
                    }
                });
                $('#clearSearch').hide();
                $('#noMatchesFound').hide();
                DashboardVM.SearchQueryDashboard('');
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | SearchDropdownChange() in Landing.js';
                logger.logMessage(msg);
            }
        }

        //#endregion


        //#region Page Navigation Methods

        function NavigateSurveyResponse(Surveys, Profiles) {
            try {
                var SurveyId = Surveys.SurveyId(),
                    SurveyName = Surveys.SurveyName(),
                    SurveyProfileId = Profiles.ProfileId(),
                    SurveyProfileName = Profiles.ProfileName(),
                    BUId = Surveys.BUId(),
                    BUName = Surveys.BUName(),
                    BUDescription = '',//Surveys.BuDescription();
                    BUType = '',//Surveys.BUType(),
                    Status = Surveys.SurveyStatus(),
                    PendingWith = Surveys.PendingWith(),
                    SurveyType = Surveys.SurveyType(),
                    CompletionPercentage = Surveys.CompletionPercentage(),
                    DueDate = Surveys.DueDate(),
                    BUList = Surveys.BUList(),
                    UserList = Surveys.UserList(),
                    GroupShortName = Surveys.GroupShortName(), //QLDR
                    SurveyTypeId = Surveys.GroupShortName(),
                    GroupName = Surveys.GroupName(),
                    GroupId = Surveys.GroupId(); //146
                SurveyIconClass = Surveys.SurveyIconClass();
                SurveyStateColor = Surveys.SurveyStateColor();
                IsCompletedFlag = Surveys.IsCompletedFlag();
                IsPendingFlag = Surveys.IsPendingFlag();
                ComponentName_Survey = Surveys.ComponentName_Survey();
                ProfileName_Survey = Surveys.ProfileName_Survey();
                SurveyStateName = Surveys.SurveyStateName();
                IsSurveyReadOnly = Surveys.IsSurveyReadOnly();

                var BUListString = "";

                if (DashboardVM.appsecurity != undefined && DashboardVM.appsecurity.userInfo() != undefined && DashboardVM.appsecurity.userInfo().PrimaryRoleId() != undefined) {
                    DashboardVM.RoleValue(DashboardVM.appsecurity.userInfo().PrimaryRoleId());
                    SelectedRoleName = DashboardVM.appsecurity.userInfo().PrimaryRoleName();
                }
                DashboardVM.ResponseMoveArray(new ResponseMoveModel({
                    SurveyId: SurveyId,
                    SurveyName: SurveyName,
                    SurveyProfileId: SurveyProfileId,
                    SurveyProfileName: SurveyProfileName,
                    GroupId: GroupId,
                    SurveyTypeId: SurveyTypeId,
                    GroupName: GroupName,
                    GroupShortName: GroupShortName,
                    PageHeaderName: GroupName,
                    BusinessUnitId: BUId,
                    BusinessUnitName: BUName,
                    BusinessUnitDescription: BUDescription,
                    BusinessType: BUType,
                    SurveyType: SurveyType,
                    RoleId: DashboardVM.RoleValue(),
                    RoleName: SelectedRoleName,
                    SurveyIconClass: SurveyIconClass,
                    SurveyStateColor: SurveyStateColor,
                    CompletionPercentage: CompletionPercentage,
                    DueDate: DueDate,
                    BUList: BUList,
                    BUListString: BUListString,
                    UserList: UserList,
                    SurveyStatus: Status,
                    PendingWith: PendingWith,
                    IsCompletedFlag: IsCompletedFlag,
                    IsPendingFlag: IsPendingFlag,
                    ComponentName_Survey: ComponentName_Survey,
                    ProfileName_Survey: ProfileName_Survey,
                    SurveyStateName: SurveyStateName,
                    IsSurveyReadOnly: IsSurveyReadOnly
                }));

                router.navigate("#survey/SurveyResponsePage", true);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | NavigateSurveyResponse() in Landing.js';
                logger.logMessage(msg);
            }
        }

        function NavigateSocializationResponse(Surveys, Profiles) {
            try {

                appsecurity.SocializationReadOnly(false);
                DashboardVM.ResponseMoveArray([]);
                var socType = 'Normal';

                var SocioRat = ko.utils.arrayFirst (DashboardVM.SocioRATsData(), function (param) {
                    if (param.ProfileId == Profiles.ProfileId()) {
                        return param;
                    }
                });

                if (Surveys.BUName() === 'Overall Socialization')
                    socType = 'Overall';

                DashboardVM.ResponseMoveArray(new ResponseMoveModel({
                    BusinessUnitId: Surveys.BUId(),
                    BusinessUnitName: Surveys.BUName(),
                    ReadOnly_FLAG: false,
                    CurrentProfileOfAssessmentId: DashboardVM.CurrentProfileOfAssessmentId(),
                    SurveyName: Surveys.SurveyName(),
                    SurveyId: Surveys.SurveyId(),
                    SurveyIconClass: Surveys.SurveyIconClass(),
                    DueDate: Surveys.DueDate(),
                    SurveyStatus: Surveys.SurveyStatus(),
                    PendingWith: Surveys.PendingWith(),
                    SurveyStateColor: Surveys.SurveyStateColor(),
                    UserList: Surveys.UserList(),
                    AssessmentType: Surveys.GroupId(), // 2 = CRA and 1 = AML/OFAC
                    AssessmentTypeId: SocioRat.RATId, // RAT_UID 
                    SurveyType: Surveys.SurveyType(),
                    IsCompletedFlag: Surveys.IsCompletedFlag(),
                    IsPendingFlag: Surveys.IsPendingFlag(),
                    BUList: Surveys.BUList(),
                    ComponentName_Survey: Surveys.ComponentName_Survey(),
                    ProfileName_Survey: Surveys.ProfileName_Survey(),
                    SurveyStateName: Surveys.SurveyStateName(),
                    SocType: socType,
                    IsSurveyReadOnly: Surveys.IsSurveyReadOnly()
                }));

                router.navigate("#RaSocialization/SocializationResponse", true);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | NavigateSocializationResponse() in Landing.js';
                logger.logMessage(msg);
            }
        }

        function NavigatePRRResponse(Surveys, Profiles) {
            try {
                var SurveyId = Surveys.SurveyId(),
                    SurveyName = Surveys.SurveyName(),
                    SurveyProfileId = Profiles.ProfileId(),
                    SurveyProfileName = Profiles.ProfileName(),
                    BUId = Surveys.BUId(),
                    BUName = Surveys.BUName(),
                    BUDescription = '',//Surveys.BuDescription();
                    BUType = '',//Surveys.BUType(),
                    Status = Surveys.SurveyStatus(),
                    PendingWith = Surveys.PendingWith(),
                    SurveyType = Surveys.SurveyType(),
                    CompletionPercentage = Surveys.CompletionPercentage(),
                    DueDate = Surveys.DueDate(),
                    BUList = Surveys.BUList(),
                    UserList = Surveys.UserList(),
                    GroupShortName = Surveys.GroupShortName(), //QLDR
                    SurveyTypeId = Surveys.GroupShortName(),
                    GroupName = Surveys.GroupName(),
                    GroupId = Surveys.GroupId(); //146
                SurveyIconClass = Surveys.SurveyIconClass();
                SurveyStateColor = Surveys.SurveyStateColor();
                IsCompletedFlag = Surveys.IsCompletedFlag();
                IsPendingFlag = Surveys.IsPendingFlag();
                ComponentName_Survey = Surveys.ComponentName_Survey();
                ProfileName_Survey = Surveys.ProfileName_Survey();
                SurveyStateName = Surveys.SurveyStateName();
                IsSurveyReadOnly = Surveys.IsSurveyReadOnly();



                if (DashboardVM.appsecurity != undefined && DashboardVM.appsecurity.userInfo() != undefined && DashboardVM.appsecurity.userInfo().PrimaryRoleId() != undefined) {
                    DashboardVM.RoleValue(DashboardVM.appsecurity.userInfo().PrimaryRoleId());
                    SelectedRoleName = DashboardVM.appsecurity.userInfo().PrimaryRoleName();
                }
                DashboardVM.ResponseMoveArray(new ResponseMoveModel({
                    SurveyId: SurveyId,
                    SurveyName: SurveyName,
                    SurveyProfileId: SurveyProfileId,
                    SurveyProfileName: SurveyProfileName,
                    GroupId: GroupId,
                    SurveyTypeId: SurveyTypeId,
                    GroupName: GroupName,
                    GroupShortName: GroupShortName,
                    PageHeaderName: GroupName,
                    BusinessUnitId: BUId,
                    BusinessUnitName: BUName,
                    BusinessUnitDescription: BUDescription,
                    BusinessType: BUType,
                    SurveyType: SurveyType,
                    RoleId: DashboardVM.RoleValue(),
                    RoleName: SelectedRoleName,
                    SurveyIconClass: SurveyIconClass,
                    SurveyStateColor: SurveyStateColor,
                    CompletionPercentage: CompletionPercentage,
                    DueDate: DueDate,
                    BUList: BUList,
                    UserList: UserList,
                    SurveyStatus: Status,
                    PendingWith: PendingWith,
                    IsCompletedFlag: IsCompletedFlag,
                    IsPendingFlag: IsPendingFlag,
                    CurrentProfileOfAssessmentId: DashboardVM.CurrentProfileOfAssessmentId(),
                    ComponentName_Survey: ComponentName_Survey,
                    ProfileName_Survey: ProfileName_Survey,
                    SurveyStateName: SurveyStateName,
                    IsSurveyReadOnly: IsSurveyReadOnly
                }));

                router.navigate("#RiskRating/RiskRatingResponsePage", true);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | NavigatePRRResponse() in Landing.js';
                logger.logMessage(msg);
            }
        }

        //#endregion


        //#region Post/Set Methods

        function MoveSurveyToWorkInProgress(Surveys, surveyTypeVar, Profiles) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/MoveSurveyToWorkInProgress?SurveyType=" + surveyTypeVar + "&SurveyID=" + Surveys.SurveyId(),
                    headers: headers,
                    type: "Post",
                    async: false
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | ajax call in MoveSurveyToWorkInProgress() in Landing.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (isNaN(jsonResult)) {
                        logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(DashboardVM), true);
                        GetDashboardData();
                    }
                    else if (!isNaN(jsonResult) && parseInt(jsonResult) == 1) {
                        SetSurveyLevelComments(Surveys, Profiles)
                    }
                    else if (!isNaN(jsonResult) && parseInt(jsonResult) == 0) {
                        app.showMessage("The Survey is either moved to another state or picked by another user. You are not allowed to perform this action.", "Action cannot be performed", [" OK"], false, { buttonClass: "fa fa-check btn", primaryButtonClass: "secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                            .then(function (option) {
                                if (option === " OK")
                                    GetDashboardData();
                            });
                    }
                    else {
                        app.showMessage("An error occurred while navigating to Response Page.", "Action cannot be performed", [" OK"], false, { buttonClass: "fa fa-check btn", primaryButtonClass: "secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                            .then(function (option) {
                                if (option === " OK")
                                    GetDashboardData();
                            });
                    }
                }
                catch (e) {
                    var msg = 'Exception' + e + 'Source: ajaxSuccess in MoveSurveyToWorkInProgress() in Landing.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage("An error occurred while performing this action. Please contact your Application Administrator.", "Error", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === "OK")
                                    GetDashboardData();

                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in MoveSurveyToWorkInProgress() method in Landing.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in MoveSurveyToWorkInProgress() method in Landing.js';
                    logger.logMessage(msg);
                }
            }
        }

        function SetSurveyLevelComments(Surveys, Profiles) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/SetSurveyLevelComments",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        Draft: Surveys.SurveyId(), AssessmentProfileId: parseInt(DashboardVM.CurrentProfileOfAssessmentId()),
                        EventId: Surveys.EventId(), CommentId: -1, RoleId: DashboardVM.RoleValue(), CommentText: Surveys.WPECommentText(),
                        CommentType: 'PBC', SurveyType: Surveys.SurveyType()
                    }),
                    type: "POST",
                    headers: headers
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SetSurveyLevelComments() method in Landing.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                        logger.logError(jsonResult + ' - An error occurred while setting the survey workflow comments.', 'Error', system.getModuleId(DashboardVM), true);
                        GetDashboardData();
                    }
                    else if (!isNaN(jsonResult) && parseInt(jsonResult) > 0) {
                        GetSurveyCardDetails(Surveys.SurveyId(), Profiles.ProfileId(), Surveys.SurveyType(), 1).then(function () {
                            Surveys.PendingWith(DashboardVM.PendingWithNav());
                            Surveys.SurveyStatus(DashboardVM.SurveyStatusNav());
                            Surveys.IsAvailableFlag(true);
                            Surveys.IsPendingFlag(false);
                            SurveyClick(Surveys, Profiles);
                        });
                    }
                    else {
                        app.showMessage("The Survey is either moved to another state or picked by another user. You are not allowed to perform this action.", "Action cannot be performed", [" OK"], false, { buttonClass: "fa fa-check btn", primaryButtonClass: "secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                            .then(function (option) {
                                if (option === " OK")
                                    GetDashboardData();
                            });
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SetSurveyLevelComments() method in Landing.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage("An error occurred while performing this action. Please contact your Application Administrator.", "Error", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === "OK")
                                    GetDashboardData();

                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SetSurveyLevelComments() method in Landing.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in SetSurveyLevelComments() method in Landing.js';
                    logger.logMessage(msg);
                }
            }
        }

        //#endregion


        //#region Models

        function ResponseMoveModel(item) {
            try {
                var self = this;
                if (DashboardVM.SurveyType() === 'SUR') {
                    self.SurveyId = ko.observable(item.SurveyId);
                    self.SurveyName = ko.observable(item.SurveyName);
                    self.SurveyProfileId = ko.observable(item.SurveyProfileId);
                    self.SurveyProfileName = ko.observable(item.SurveyProfileName);
                    self.GroupId = ko.observable(item.GroupId);
                    self.GroupName = ko.observable(item.GroupName);
                    self.GroupShortName = ko.observable(item.GroupShortName);
                    self.BusinessUnitId = ko.observable(item.BusinessUnitId);
                    self.BusinessUnitName = ko.observable(item.BusinessUnitName);
                    self.BusinessUnitDescription = ko.observable(item.BusinessUnitDescription); // not passing
                    self.BusinessType = ko.observable(item.BusinessType); // not passing
                    self.SurveyType = ko.observable(item.SurveyType); // to differentiate surveys like RA survey(SUR), socialization survey(SOC)
                    self.RoleId = ko.observable(item.RoleId);
                    self.RoleName = ko.observable(item.RoleName);
                    self.SurveyTypeId = ko.observable(item.SurveyTypeId);
                    self.CompletionPercentage = ko.observable(item.CompletionPercentage);
                    self.DueDate = ko.observable(item.DueDate);
                    self.BUList = ko.observable(item.BUList);
                    self.BUListString = ko.observable(item.BUListString);
                    self.UserList = ko.observable(item.UserList);
                    self.SurveyStatus = ko.observable(item.SurveyStatus);
                    self.PendingWith = ko.observable(item.PendingWith);
                    self.SurveyIconClass = ko.observable(item.SurveyIconClass);
                    self.SurveyStateColor = ko.observable(item.SurveyStateColor);
                    self.IsCompletedFlag = ko.observable(item.IsCompletedFlag);
                    self.IsPendingFlag = ko.observable(item.IsPendingFlag);
                    self.ComponentName_Survey = ko.observable(item.ComponentName_Survey);
                    self.ProfileName_Survey = ko.observable(item.ProfileName_Survey);
                    self.SurveyStateName = ko.observable(item.SurveyStateName);
                    self.IsSurveyReadOnly = ko.observable(item.IsSurveyReadOnly);
                }
                else if (DashboardVM.SurveyType() === 'SOC') {

                    self.BusinessUnitId = ko.observable(item.BusinessUnitId);
                    self.BusinessUnitName = ko.observable(item.BusinessUnitName);
                    self.SurveyName = ko.observable(item.SurveyName);
                    self.SurveyId = ko.observable(item.SurveyId);
                    self.ReadOnly_FLAG = ko.observable(item.ReadOnly_FLAG);
                    self.SurveyIconClass = ko.observable(item.SurveyIconClass);
                    self.DueDate = ko.observable(item.DueDate);
                    self.SurveyStatus = ko.observable(item.SurveyStatus);
                    self.PendingWith = ko.observable(item.PendingWith);
                    self.SurveyStateColor = ko.observable(item.SurveyStateColor);
                    self.UserList = ko.observable(item.UserList);
                    self.CurrentProfileOfAssessmentId = ko.observable(item.CurrentProfileOfAssessmentId);
                    self.AssessmentType = ko.observable(item.AssessmentType);
                    self.AssessmentTypeId = ko.observable(item.AssessmentTypeId);
                    self.SurveyType = ko.observable(item.SurveyType);
                    self.IsCompletedFlag = ko.observable(item.IsCompletedFlag);
                    self.IsPendingFlag = ko.observable(item.IsPendingFlag);
                    self.BUList = ko.observable(item.BUList);
                    self.ComponentName_Survey = ko.observable(item.ComponentName_Survey);
                    self.ProfileName_Survey = ko.observable(item.ProfileName_Survey);
                    self.SurveyStateName = ko.observable(item.SurveyStateName);
                    self.SocType = ko.observable(item.SocType);
                    self.IsSurveyReadOnly = ko.observable(item.IsSurveyReadOnly);
                }
                else if (DashboardVM.SurveyType() === 'PCS') {
                    self.SurveyId = ko.observable(item.SurveyId);
                    self.SurveyName = ko.observable(item.SurveyName);
                    self.SurveyProfileId = ko.observable(item.SurveyProfileId);
                    self.SurveyProfileName = ko.observable(item.SurveyProfileName);
                    self.GroupId = ko.observable(item.GroupId);
                    self.GroupName = ko.observable(item.GroupName);
                    self.GroupShortName = ko.observable(item.GroupShortName);
                    self.BusinessUnitId = ko.observable(item.BusinessUnitId);
                    self.BusinessUnitName = ko.observable(item.BusinessUnitName);
                    self.BusinessUnitDescription = ko.observable(item.BusinessUnitDescription); // not passing
                    self.BusinessType = ko.observable(item.BusinessType); // not passing
                    self.SurveyType = ko.observable(item.SurveyType); // to differentiate surveys like RA survey(SUR), socialization survey(SOC)
                    self.RoleId = ko.observable(item.RoleId);
                    self.RoleName = ko.observable(item.RoleName);
                    self.SurveyTypeId = ko.observable(item.SurveyTypeId);
                    self.CompletionPercentage = ko.observable(item.CompletionPercentage);
                    self.DueDate = ko.observable(item.DueDate);
                    self.BUList = ko.observable(item.BUList);
                    self.UserList = ko.observable(item.UserList);
                    self.SurveyStatus = ko.observable(item.SurveyStatus);
                    self.PendingWith = ko.observable(item.PendingWith);
                    self.SurveyIconClass = ko.observable(item.SurveyIconClass);
                    self.SurveyStateColor = ko.observable(item.SurveyStateColor);
                    self.IsCompletedFlag = ko.observable(item.IsCompletedFlag);
                    self.IsPendingFlag = ko.observable(item.IsPendingFlag);
                    self.ComponentName_Survey = ko.observable(item.ComponentName_Survey);
                    self.ProfileName_Survey = ko.observable(item.ProfileName_Survey);
                    self.CurrentProfileOfAssessmentId = ko.observable(item.CurrentProfileOfAssessmentId);
                    self.SurveyStateName = ko.observable(item.SurveyStateName);
                    self.IsSurveyReadOnly = ko.observable(item.IsSurveyReadOnly);
                }
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: ResponseMoveModel() in Landing.js';
                logger.logMessage(msg);
            }
        }

        //#endregion
    });

